import { httpClient } from '@/httpClient/axios.ts';
import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import Cookies from 'js-cookie';
import { useEncryptPayload } from '@/saveRegistration/useEncryptPayload.ts';
import { useForm } from '@/form/useForm.ts';

export const useTransmitRequest = () => {
  const meta = useAppConfig();
  const { getFormPayload } = useForm();
  const { encrypt } = useEncryptPayload();

  // This request is called with the current data store in FormDataProvider. It encrypts the plain data
  // before transmission
  const transmitExistingFormPayload = async () => {
    const headers = {
      'Content-Type': 'application/encrypted',
      'Content-Transfer-Encoding': 'base64',
      'X-CSRFToken': Cookies.get('csrftoken'),
    };
    if (!meta) {
      return Promise.reject();
    }
    const url = meta.api.registrations;
    const payload = getFormPayload();
    const ciphertext = await encrypt(payload);

    return httpClient.post(url, ciphertext, {
      headers: headers,
    });
  };

  return { transmitExistingFormPayload };
};
